import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import '../Styles/Home.css';
import { FiLogOut, FiMenu, FiUsers } from 'react-icons/fi';
import { Icon, addCollection } from '@iconify/react';
import flatColorData from '@iconify-json/flat-color-icons/icons.json';
import logo from '../Images/SAVI AI full.png';
import SaviHalfLogo from '../Images/SAVI AI Halff.png';

addCollection(flatColorData);

const Home = () => {
  const navigate = useNavigate();
  const userName = localStorage.getItem('user') || 'User';
  const userInitial = userName.charAt(0).toUpperCase();
  const [isSidebarActive, setIsSidebarActive] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarActive(!isSidebarActive);
  };

  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('user');
    localStorage.removeItem('userType');
    localStorage.removeItem('authMethod');
    navigate('/', { replace: true });
  };

  return (
    <div className="home-container">
      {isSidebarActive && window.innerWidth <= 426 && (
        <div
          className="sidebar-overlay"
          onClick={toggleSidebar}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            zIndex: 998,
            background: 'rgba(0, 0, 0, 0.25)',
          }}
        />
      )}
      <div className={`sidebar ${isSidebarActive ? 'active' : 'collapsed'}`}>
        <div className="hamburger-menu-container">
          <div className="hamburger-menu" onClick={toggleSidebar}>
            <button className="menu-btn">
              <FiMenu size={20} />
            </button>
          </div>
          {!isSidebarActive && (
            <div
              className="logo-container1"
              onClick={toggleSidebar}
              style={{ cursor: 'pointer' }}
            >
              <img src={SaviHalfLogo} alt="SAVI Half Logo" style={{ width: 30, height: 30 }} />
            </div>
          )}
          <div className="logo-container2" style={{ cursor: 'default' }}>
            <img src={logo} alt="SAVI Logo" style={{ width: 53, height: 19 }} />
          </div>
        </div>

        <div className="sidebar-section1">
          <h3 className="section-title">Agents</h3>
          <nav className="sidebar-nav home-sidebar-nav" style={{ display: 'block', padding: 0, margin: 0 }}>
            <button
              className="nav-btn home-nav-btn active"
              title="GR/IR Reconciliation"
              style={{
                display: 'flex', alignItems: 'center', gap: '10px',
                height: '38px', padding: '0 12px 0 9px', margin: '0',
                fontSize: '14px', fontWeight: 600, lineHeight: '1',
                background: '#ffffff', border: 'none', borderLeft: '3px solid #5b5fc7',
                borderRadius: '0 4px 4px 0', width: '100%', cursor: 'pointer',
                textAlign: 'left', color: '#242424', boxSizing: 'border-box',
                boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
              }}
            >
              <FiUsers size={16} />
              {isSidebarActive && <span>GR/IR Reconciliation</span>}
            </button>
          </nav>
        </div>

        <div className="sidebar-footer">
          {isSidebarActive ? (
            <>
              <div className="sidebar-user-section">
                <div className="user-badge">
                  <div className="user-avatar">{userInitial}</div>
                  <span className="user-name">{userName}</span>
                </div>
              </div>
              <button className="footer-btn" onClick={handleLogout} title="Logout">
                <FiLogOut size={16} />
                <span>Logout</span>
              </button>
            </>
          ) : (
            <button className="footer-btn" onClick={handleLogout} title="Logout">
              <FiLogOut size={16} />
            </button>
          )}
        </div>
      </div>

      {/* Main content */}
      <div className="home-main-wrapper">
        <motion.main
          className="home-main"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4 }}
        >
          <motion.div
            className="home-main-inner"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <motion.div
              className="page-title-wrapper"
              initial={{ x: -20, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <h1 className="page-title">Agents</h1>
            </motion.div>

            <motion.div
              className="section-block"
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
            >
              <h2 className="section-heading">Built by SAVIC</h2>
            </motion.div>

            <motion.div
              className="agent-grid"
              initial="hidden"
              animate="visible"
              variants={{
                hidden: { opacity: 0 },
                visible: {
                  opacity: 1,
                  transition: { staggerChildren: 0.08, delayChildren: 0.3 },
                },
              }}
            >
              <motion.div
                className="agent-card"
                onClick={() => navigate('/grir')}
                variants={{
                  hidden: { opacity: 0, y: 20, scale: 0.95 },
                  visible: {
                    opacity: 1,
                    y: 0,
                    scale: 1,
                    transition: { type: 'spring', stiffness: 100, damping: 15 },
                  },
                }}
                whileHover={{ y: -6, scale: 1.02, transition: { duration: 0.2 } }}
                whileTap={{ scale: 0.98 }}
              >
                <motion.div
                  className="agent-icon"
                  whileHover={{ rotate: [0, -10, 10, -10, 0], scale: 1.1 }}
                  transition={{ duration: 0.5 }}
                >
                  <Icon icon="flat-color-icons:synchronize" width={36} height={36} />
                </motion.div>
                <div className="agent-content">
                  <h3 className="agent-title">GR/IR reconciliation</h3>
                  <p className="agent-description">Match goods receipts with invoice receipts seamlessly</p>
                </div>
              </motion.div>
            </motion.div>
          </motion.div>
        </motion.main>
      </div>
    </div>
  );
};

export default Home;
